import React, { useContext } from "react";
import { AuthContext } from "../AuthContextComponent";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

interface TableRowProps {
  data: (string | number | any)[];
  isHeader?: boolean;
  index?: number;
  isApprove?: boolean; // Keep isApprove prop
  isReprocess?: boolean;
  isChecked?: boolean;
  isCheckedAll?: boolean;
  onApprove?: (index?: number) => void; // Callback for approve action
  onDecline?: (index?: number) => void; // Callback for decline action
  onView?: (index?: number) => void; // Callback for view action
  onCheckBoxChange?: () => void;
  onCheckBoxAllChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TableRow = ({
  data,
  isHeader,
  isApprove,
  isReprocess,
  isChecked,
  isCheckedAll,
  onApprove,
  onDecline,
  onView,
  index,
  onCheckBoxChange,
  onCheckBoxAllChange,
}: TableRowProps) => {
  const { userInfo } = useContext(AuthContext);
  const color = userInfo?.theme === "DARK" ? "#fafbfc" : "black";

  return (
    <tr
      className={`font-sans text-custom-micro ${
        isHeader
          ? `font-semibold border-t border-b`
          : `${
              userInfo?.theme === `DARK`
                ? `hover:bg-black hover:text-black`
                : `hover:bg-stone-200`
            }`
      }`}
      style={{ width: "162px", height: "40px" }} // Set width and height for the row
    >
      {isReprocess && isHeader && (
        <td className="text-center border-b border-gray-300 px-7">
          <div className="flex items-center justify-center h-full">
            <input
              type="checkbox"
              checked={isCheckedAll}
              onChange={onCheckBoxAllChange}
            />
          </div>
        </td>
      )}
      {isReprocess && !isHeader && (
        <td className="text-center border-b border-gray-300 px-7">
          <div className="flex items-center justify-center h-full">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={onCheckBoxChange}
            />
          </div>
        </td>
      )}
      {/* {isReprocess && !isHeader && (
        <td className="py-2 px-2 text-left border-b border-gray-300">
          <div className="flex flex-row gap-2">
            <button
              className={`text-custom-micro rounded-md px-5 bg-green-600 text-white py-1 hover:scale-110 ${
                userInfo?.theme === "DARK"
                  ? "text-green-500 hover:text-white"
                  : "text-green-500 hover:text-white"
              }`}
              onClick={() => onApprove && onApprove(index)}
            >
              MCASH
            </button>
            <button
              className={`text-custom-micro rounded-md px-5 bg-green-600 text-white py-1 hover:scale-110 ${
                userInfo?.theme === "DARK"
                  ? "text-red-500 hover:text-white"
                  : "text-gray-500 hover:text-white"
              }`}
              disabled
              onClick={() => onDecline && onDecline(index)}
            >
              BRANCH
            </button>
          </div>
          {/* <div className="relative inline-block group"></div> */}
      {/* </td>  */}
      {/* // )} */}
      {data.map((cellData, cellIndex) => (
        <td
          key={cellIndex}
          className={` px-2 border-b border-gray-300 text-custom-micro ${
            isHeader ? "text-center" : "text-left"
          }`}
          style={{
            width: "162px", // Width for individual cells
            height: "40px", // Height for individual cells
            color,
            wordWrap: "break-word",
            overflowWrap: "break-word",
          }}
        >
          {isHeader ? (
            <div className="text-left md:text-custom-micro text-xs font-sans h-auto w-[200px]">
              {cellData}
            </div>
          ) : (
            <div className="text-left md:text-custom-micro text-xs font-sans h-auto w-full">
              {cellData}
            </div>
          )}
        </td>
      ))}
      {isApprove && !isHeader && (
        <td className="py-2 px-2 text-left border-b border-gray-300">
          <div className="relative inline-block group gap-x-10">
            <button
              className={`text-xl rounded-md px-5 py-1 hover:scale-110 ${
                userInfo?.theme === "DARK"
                  ? "text-green-500 hover:text-green-600"
                  : "text-green-500 hover:text-green-600"
              }`}
              onClick={() => onApprove && onApprove(index)}
            >
              <FaCheckCircle />
            </button>
            <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 w-max bg-gray-700 text-white text-sm rounded-md p-1 opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100">
              Approve
            </span>
          </div>
          <div className="relative inline-block group">
            <button
              className={`text-xl rounded-md px-8 py-1 hover:scale-110 ${
                userInfo?.theme === "DARK"
                  ? "text-red-500 hover:text-red-500"
                  : "text-gray-500 hover:text-gray-600"
              }`}
              onClick={() => onDecline && onDecline(index)}
            >
              <FaTimesCircle />
            </button>
            <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 w-max bg-gray-700 text-white text-sm rounded-md p-1 opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100">
              Reject
            </span>
          </div>
        </td>
      )}
    </tr>
  );
};

export default TableRow;
